/**
 * The Company Projects page's address.
 *
 * EQU-1219: the sidebar's Company Projects row used to open the Projects tab
 * of Project Management, carrying its filters in router state. The address bar
 * then read `/workflow/projects` — the same URL All Projects → Projects gives
 * — so the page could not be linked, bookmarked or told apart. It is its own
 * page at its own address now, and the company filter there is the company the
 * sidebar shows rather than a preset the tab could overwrite.
 */

/** The Company Projects page: one company's projects, on its own address. */
export const COMPANY_PROJECTS_PATH = "/companyprojects";

/**
 * Whether this location is the Company Projects page. Both sidebar menus
 * decide their highlight from it, so exactly one of them highlights: the
 * company panel's row here, and no All Projects entry (EQ-2488).
 */
export function isCompanyProjectsPath(pathname: string): boolean {
	return pathname === COMPANY_PROJECTS_PATH;
}
